// Room data
export const rooms = [
    {
        id: 'luxury-1',
        name: 'Luxury 1',
        tagline: 'Where Elegance Meets Nature',
        description: 'A spacious luxury room with panoramic valley views. Wake up to misty mornings and fall asleep under the starlit sky. Equipped with premium bedding, modern amenities, and a private balcony overlooking the lush Kookal valley.',
        features: ['Valley View', 'Private Balcony', 'Premium Bedding', 'Hot Water', 'Room Service'],
        capacity: '7 Guests',
        type: 'luxury',
        images: [
            '/images/rooms/luxury-1.webp',
            '/images/rooms/luxury-1-1.webp',
            '/images/rooms/luxury-1-2.webp',
            '/images/rooms/luxury-1-3.webp',
        ],
    },
    {
        id: 'luxury-2',
        name: 'Luxury 2',
        tagline: 'Your Private Hill Retreat',
        description: 'An exquisitely designed luxury room that blends rustic charm with modern comfort. Featuring handcrafted wooden interiors, floor-to-ceiling windows framing the garden, and a cozy reading nook.',
        features: ['Garden View', 'Reading Nook', 'Premium Bedding', 'Hot Water', 'Room Service'],
        capacity: '8 Guests',
        type: 'luxury',
        images: [
            '/images/rooms/luxury-2.webp',
            '/images/rooms/luxury-2-1.webp',
            '/images/rooms/luxury-2-2.webp',
            '/images/rooms/luxury-2-3.webp',
            '/images/rooms/luxury-2-4.webp',
        ],
    },
    {
        id: 'bunkers-1',
        name: 'Bunkers 1',
        tagline: 'Adventure Meets Comfort',
        description: 'A vibrant bunk room designed for groups and adventure seekers. Featuring sturdy, hand-crafted bunk beds with individual reading lights, privacy curtains, and personal storage. Perfect for families and friend groups.',
        features: ['Bunk Beds', 'Individual Lights', 'Storage Space', 'Hot Water', 'Common Area Access'],
        capacity: '9 Guests',
        type: 'bunker',
        images: [
            '/images/rooms/bunkers-1.webp',
            '/images/rooms/bunkers-1-1.webp',
            '/images/rooms/bunkers-1-2.webp',
        ],
    },
    {
        id: 'bunkers-2',
        name: 'Bunkers 2',
        tagline: 'Cozy Group Hideaway',
        description: 'Another beautifully designed bunk room with a warm, inviting atmosphere. Each bunk comes with comfortable mattresses and soft linens. The room opens to a shared lounge area with board games and books.',
        features: ['Bunk Beds', 'Lounge Access', 'Board Games', 'Hot Water', 'Common Area Access'],
        capacity: '11 Guests',
        type: 'bunker',
        images: [
            '/images/rooms/bunkers-2.webp',
            '/images/rooms/bunkers-2-1.webp',
            '/images/rooms/bunkers-2-2.webp',
        ],
    },
];

// Amenities data
export const amenities = [
    {
        id: 'food',
        name: 'Home-Cooked Meals',
        description: 'Savor authentic South Indian cuisine and local Kodaikanal specialties prepared with fresh, locally-sourced ingredients.',
        icon: 'food',
    },
    {
        id: 'campfire',
        name: 'Campfire Nights',
        description: 'Gather around the crackling campfire under a sky filled with stars. Perfect for storytelling, music, and unforgettable memories.',
        icon: 'campfire',
    },
    {
        id: 'valley-view',
        name: 'Valley Views',
        description: 'Breathtaking panoramic views of the Kookal valley. Watch the clouds roll in and the sun paint the sky at dawn and dusk.',
        icon: 'view',
    },
    {
        id: 'lake',
        name: 'Kookal Lake Nearby',
        description: 'A short walk takes you to the pristine Kookal Lake, surrounded by ancient shola forests and rolling grasslands.',
        icon: 'lake',
    },
    {
        id: 'nature',
        name: 'Nature Trails',
        description: 'Explore winding trails through lush forests, discover hidden waterfalls, and spot exotic birds and butterflies.',
        icon: 'nature',
    },
    {
        id: 'parking',
        name: 'Free Parking',
        description: 'Secure, complimentary parking space available for all guests right at the property.',
        icon: 'parking',
    },
];

// Gallery categories
export const galleryCategories = ['All', 'Rooms', 'Surroundings', 'Amenities', 'Experiences'];

// Gallery images mapped to actual photo files
export const galleryImages = [
    // Rooms
    { id: 1, src: '/images/rooms/luxury-1.webp', alt: 'Luxury Room 1', caption: 'Luxury Room 1 – Elegant interiors', category: 'Rooms' },
    { id: 2, src: '/images/rooms/luxury-1-1.webp', alt: 'Luxury Room 1 - View 2', caption: 'Luxury Room 1 – Another angle', category: 'Rooms' },
    { id: 3, src: '/images/rooms/luxury-1-2.webp', alt: 'Luxury Room 1 - View 3', caption: 'Luxury Room 1 – Cozy details', category: 'Rooms' },
    { id: 4, src: '/images/rooms/luxury-1-3.webp', alt: 'Luxury Room 1 - View 4', caption: 'Luxury Room 1 – Premium comfort', category: 'Rooms' },
    { id: 5, src: '/images/rooms/luxury-2.webp', alt: 'Luxury Room 2', caption: 'Luxury Room 2 – Charming interiors', category: 'Rooms' },
    { id: 6, src: '/images/rooms/luxury-2-1.webp', alt: 'Luxury Room 2 - View 2', caption: 'Luxury Room 2 – Warm ambiance', category: 'Rooms' },
    { id: 7, src: '/images/rooms/luxury-2-2.webp', alt: 'Luxury Room 2 - View 3', caption: 'Luxury Room 2 – Rustic elegance', category: 'Rooms' },
    { id: 8, src: '/images/rooms/luxury-2-3.webp', alt: 'Luxury Room 2 - View 4', caption: 'Luxury Room 2 – Hill retreat vibes', category: 'Rooms' },
    { id: 9, src: '/images/rooms/luxury-2-4.webp', alt: 'Luxury Room 2 - View 5', caption: 'Luxury Room 2 – Every detail matters', category: 'Rooms' },
    { id: 10, src: '/images/rooms/bunkers-1.webp', alt: 'Bunkers 1', caption: 'Bunkers 1 – Cozy bunk room', category: 'Rooms' },
    { id: 11, src: '/images/rooms/bunkers-1-1.webp', alt: 'Bunkers 1 - View 2', caption: 'Bunkers 1 – Adventure-ready', category: 'Rooms' },
    { id: 12, src: '/images/rooms/bunkers-1-2.webp', alt: 'Bunkers 1 - View 3', caption: 'Bunkers 1 – Group-friendly space', category: 'Rooms' },
    { id: 13, src: '/images/rooms/bunkers-2.webp', alt: 'Bunkers 2', caption: 'Bunkers 2 – Warm and inviting', category: 'Rooms' },
    { id: 14, src: '/images/rooms/bunkers-2-1.webp', alt: 'Bunkers 2 - View 2', caption: 'Bunkers 2 – Comfortable bunks', category: 'Rooms' },
    { id: 15, src: '/images/rooms/bunkers-2-2.webp', alt: 'Bunkers 2 - View 3', caption: 'Bunkers 2 – Shared comforts', category: 'Rooms' },
    // Surroundings
    { id: 16, src: '/images/surroundings/valley.webp', alt: 'Valley View', caption: 'Panoramic view of the Kookal valley', category: 'Surroundings' },
    { id: 17, src: '/images/surroundings/front.webp', alt: 'Property Front View', caption: 'UC Eden Valley – Front view', category: 'Surroundings' },
    { id: 18, src: '/images/surroundings/front-night.webp', alt: 'Property at Night', caption: 'Eden Valley glowing at night', category: 'Surroundings' },
    { id: 19, src: '/images/surroundings/lawn.webp', alt: 'Lawn', caption: 'The lush green lawn', category: 'Surroundings' },
    { id: 20, src: '/images/surroundings/lawn-1.webp', alt: 'Lawn View', caption: 'Lawn with a view of the hills', category: 'Surroundings' },
    { id: 21, src: '/images/surroundings/lawn-2.webp', alt: 'Garden Area', caption: 'Relaxing garden space', category: 'Surroundings' },
    { id: 22, src: '/images/surroundings/lawn-3.webp', alt: 'Lawn Panorama', caption: 'Sprawling lawns surrounded by nature', category: 'Surroundings' },
    { id: 23, src: '/images/surroundings/lake.webp', alt: 'Kookal Lake', caption: 'The serene Kookal Lake', category: 'Surroundings' },
    { id: 24, src: '/images/surroundings/lake-1.webp', alt: 'Kookal Lake View', caption: 'Kookal Lake – A short walk away', category: 'Surroundings' },
    { id: 25, src: '/images/surroundings/lake-3.webp', alt: 'Lake Surroundings', caption: 'Peaceful waters of Kookal Lake', category: 'Surroundings' },
    { id: 26, src: '/images/surroundings/lake-4.webp', alt: 'Lake Scenery', caption: 'Kookal Lake covered in morning mist', category: 'Surroundings' },
    { id: 27, src: '/images/surroundings/night-view.webp', alt: 'Night View', caption: 'Starry night view from Eden Valley', category: 'Surroundings' },
    { id: 28, src: '/images/surroundings/path-at-night.webp', alt: 'Night Path', caption: 'The enchanting path at night', category: 'Surroundings' },
    // Amenities
    { id: 29, src: '/images/amenities/camp-fire.webp', alt: 'Campfire', caption: 'Campfire under the starlit sky', category: 'Amenities' },
    { id: 30, src: '/images/amenities/parking.webp', alt: 'Parking', caption: 'Free and secure parking for guests', category: 'Amenities' },
    { id: 31, src: '/images/amenities/tv.webp', alt: 'Entertainment', caption: 'Entertainment amenities for downtime', category: 'Amenities' },
    // Experiences
    { id: 32, src: '/images/experiences/evening.webp', alt: 'Evening View', caption: 'Magical evenings at Eden Valley', category: 'Experiences' },
    { id: 33, src: '/images/experiences/misty-evening.webp', alt: 'Misty Evening', caption: 'Mist rolling in over the hills', category: 'Experiences' },
    { id: 34, src: '/images/experiences/sun-hides.webp', alt: 'Sun Hides', caption: 'The sun hiding behind the clouds', category: 'Experiences' },
    { id: 35, src: '/images/experiences/sun-kissed.webp', alt: 'Sun Kissed', caption: 'Sun-kissed hills of Kodaikanal', category: 'Experiences' },
    { id: 36, src: '/images/experiences/sun-set.webp', alt: 'Sunset', caption: 'Golden sunset over the valley', category: 'Experiences' },
];

// Testimonials
export const testimonials = [
    {
        id: 1,
        name: 'Priya Sharma',
        location: 'Bangalore',
        text: 'UC Eden Valley is a hidden gem! The valley views from our luxury room were absolutely breathtaking. The home-cooked food was the cherry on top. We couldn\'t have asked for a better getaway.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Rahul Menon',
        location: 'Chennai',
        text: 'We booked both bunker rooms for our college reunion. The campfire night was magical – sitting under a sky full of stars, sharing stories. The hosts made us feel right at home.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Ananya & Vikram',
        location: 'Mumbai',
        text: 'The perfect anniversary escape. Waking up to misty mornings with a hot cup of coffee on the private balcony – pure bliss. The walk to Kookal Lake was serene and rejuvenating.',
        rating: 5,
    },
];

// WhatsApp number (without + symbol)
export const WHATSAPP_NUMBER = '916374422556';
